import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-6" };
const _hoisted_2 = { class: "text-base font-semibold text-(--colors-text-heading) mb-3" };
const _hoisted_3 = { class: "flex flex-col gap-2" };
const _hoisted_4 = { class: "sr-only" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserRolesMatrix',
    props: {
        groups: {},
        editable: { type: Boolean },
        lockedTypes: {}
    },
    emits: ["toggle"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function isLocked(type) {
            return props.lockedTypes?.includes(type) ?? false;
        }
        function onItemClick(item) {
            if (!props.editable || isLocked(item.type))
                return;
            emit("toggle", item.type);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groups, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: group.key
                    }, [
                        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t(`accessManager.userDetail.roles.modules.${group.key}`)), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                                return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.editable ? 'button' : 'div'), {
                                    key: item.type,
                                    type: __props.editable ? 'button' : undefined,
                                    disabled: __props.editable && isLocked(item.type),
                                    "aria-pressed": __props.editable ? item.owned : undefined,
                                    "data-testid": `role-matrix-item-${item.type}`,
                                    class: _normalizeClass(["flex items-center gap-2", __props.editable && !isLocked(item.type) ? 'cursor-pointer text-left hover:opacity-80' : 'text-left']),
                                    onClick: ($event) => (onItemClick(item))
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("i", {
                                            class: _normalizeClass(item.owned
                                                ? 'ri-checkbox-circle-line text-(--colors-icon-success)'
                                                : 'ri-close-circle-line text-(--colors-icon-disabled)'),
                                            "aria-hidden": "true"
                                        }, null, 2 /* CLASS */),
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(item.owned
                                            ? _ctx.$t("accessManager.userDetail.roles.matrixOwned")
                                            : _ctx.$t("accessManager.userDetail.roles.matrixNotOwned")), 1 /* TEXT */),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(item.owned
                                                ? 'text-(--colors-text-black-default)'
                                                : 'text-(--colors-text-disabled)')
                                        }, _toDisplayString(item.label), 3 /* TEXT, CLASS */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type", "disabled", "aria-pressed", "data-testid", "class", "onClick"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ]));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
